<template>
    <div>
        <div class="nev-left">
            <div class="panel-group">
                <div class="panel panel-default" v-for="(menu, index) in twoMenuData" :key="menu.name"> 
                    <div class="panel-heading" >
                        <h4 class="panel-title" @click="menuActive(index)" style="cursor: pointer;">
                            <a class="accordion-toggle" >
                                <img v-if="$isAis" :src="imagePath(menu.icon,menu.isActive)" > 
                                <span v-else class="iconfont menu-iconfont" :class="[menu.iconfont,{'menu-iconfont-active': menu.isActive}]"></span>
                                <span class="name-menu nav-active" :class="{'active-menu-text-green': menu.isActive}"> {{menu.name}} </span>
                                <span 
                                    v-if="menu.thrMenu"
                                    class="glyphicon  pull-right ico-chevron"
                                    :class="{'glyphicon-chevron-right': !menu.isActive,'glyphicon-chevron-down': menu.isActive}"
                                    ></span>
                            </a>
                        </h4>
                    </div>
                    <div class="panel-collapse collapse" :class="{'in': menu.isActive && menu.thrMenu}" >
                        <div class="panel-body">
                            <ul class="list-unstyled collapse-child">
                                <li v-for="(thrMenu,thrMenuIndex) in menu.thrMenu" 
                                    :key="thrMenu.name" 
                                    :class="{active:thrMenu.isActive}"
                                    @click="thrMenuActive(index,thrMenuIndex)">
                                    <a ><span>|</span> &nbsp; {{thrMenu.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="warp-content">
            <div v-if="!isShowBridge && $G_DEVICE_CFG.isBridge" class="bridge-text">
                <p>Bridge mode this feature page is not available</p> 
                <p class="bridge-text-tips">Tips:You can turn off Filink or wireless relay switch or restore factory settings, restore the device to router mode.</p>
            </div>
            <component v-else-if="isVueComponent" v-bind:is="componentId"></component>
            <iframe v-else :src="iframeUrl" frameborder="0"></iframe>
        </div>
    </div>

</template>

<script>
import MenuData from "@/fhMenu"
import devConfig from '@/devConfig'

export default {
    data() {
        return {
            twoMenuData: {},
            isVueComponent:false,
            iframeUrl:"",
            currentTabComponent:"",
            isShowBridge:true
            
        }
    },
    beforeMount:function (){
        /**设备能力及初始化 */
        devConfig.init(this,()=>{
            this.initTwoMenuData();
            let twoIndex = this.$route.query.twoIndex ? this.$route.query.twoIndex : 0;
            let thrMenuIndex = this.$route.query.thrMenuIndex ? this.$route.query.thrMenuIndex : 0;
            this.initActive(twoIndex,thrMenuIndex);
        })
        
    },
    computed: {
        componentId () {
            if(this.$route.name != 'home')
                return require(`@/views/${this.$route.name}/${this.currentTabComponent}`).default
            else
                return
        }
    },
    watch: {
        '$route' (to, from) {
            this.initTwoMenuData();
            let twoIndex = to.query.twoIndex ? to.query.twoIndex : 0;
            let thrMenuIndex = to.query.thrMenuIndex ? to.query.thrMenuIndex : 0;
            this.initActive(twoIndex,thrMenuIndex);
        }
    },
    methods:{
        imagePath: function (url,isActive) {
            if(isActive)
                url = url.replace(/_0.png/i,"_1.png")
            else
                url = url.replace(/_1.png/i,"_0.png")
            return require('@/assets/' + url) 
        },
        initTwoMenuData:function () {
            let _menuData = {};
            let url = this.$route.name;
            MenuData.getMenu().forEach(element => {
                if (element.url === url && element.twoMenu) {
                    _menuData = element.twoMenu
                }
            });
            this.twoMenuData = _menuData;
        },
        initActive: function (twoIndex,thrMenuIndex) {
           
            if(this.twoMenuData[twoIndex])
            {
                this.menuActive(twoIndex);
                if(this.twoMenuData[twoIndex].thrMenu 
                    && this.twoMenuData[twoIndex].thrMenu[thrMenuIndex])
                {
                    this.thrMenuActive(twoIndex,thrMenuIndex);
                }
            }
        },
        menuActive: function (menuIndex) {  
            this.twoMenuData.forEach(element => {
                element.isActive = false;
                if(element.thrMenu)
                {
                    element.thrMenu.forEach(element => {
                        element.isActive = false;
                    });
                }
            });
            this.twoMenuData[menuIndex].isActive = true;
            if(!this.twoMenuData[menuIndex].thrMenu )
            {
                if(this.twoMenuData[menuIndex].componentName)
                {
                    this.isVueComponent = true;
                    this.currentTabComponent = this.twoMenuData[menuIndex].componentName;
                    if(typeof this.twoMenuData[menuIndex].isShowBridge != "undefined")
                        this.isShowBridge = this.twoMenuData[menuIndex].isShowBridge
                    else
                        this.isShowBridge = true
                }

                if(this.twoMenuData[menuIndex].url)
                {
                    this.isVueComponent = false;
                    this.iframeUrl = this.twoMenuData[menuIndex].url;
                }
            }
              
        },
        thrMenuActive: function (menuIndex,thrMenuIndex) {
            this.twoMenuData[menuIndex].thrMenu.forEach(element =>{
                element.isActive = false;
            });
            this.twoMenuData[menuIndex].thrMenu[thrMenuIndex].isActive = true;

            if(this.twoMenuData[menuIndex].thrMenu[thrMenuIndex].componentName)
            {
                this.isVueComponent = true;
                this.currentTabComponent = this.twoMenuData[menuIndex].thrMenu[thrMenuIndex].componentName;
                if(typeof this.twoMenuData[menuIndex].thrMenu[thrMenuIndex].isShowBridge != "undefined")
                    this.isShowBridge = this.twoMenuData[menuIndex].thrMenu[thrMenuIndex].isShowBridge;
                else
                    this.isShowBridge = true
            }

            if(this.twoMenuData[menuIndex].thrMenu[thrMenuIndex].url)
            {
                this.isVueComponent = false;
                this.iframeUrl = this.twoMenuData[menuIndex].thrMenu[thrMenuIndex].url;
            }

    
             
        }
    },

}


</script>



